import { Alert, Notification, toast } from "components/ui"
import { isArray, isString, orderBy } from "lodash"
import dayjs from 'dayjs'
import relativeTime from "dayjs/plugin/relativeTime";
import es from "dayjs/locale/es"
import utc from "dayjs/plugin/utc";
import duration from 'dayjs/plugin/duration'
import isToday from "dayjs/plugin/isToday";
import tz from "dayjs/plugin/timezone"
import { getKey } from "./localStorage";
import moment from "moment";
import 'moment/locale/es';
moment.locale('es');

dayjs.extend(relativeTime)
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(isToday)
dayjs.extend(tz)


export const tenantTimezone = getKey('admin')?.auth ? JSON.parse(JSON.parse(getKey('admin'))?.auth)?.user?.timezone?.code || 'America/Argentina/Buenos_Aires' : 'America/Argentina/Buenos_Aires'

// Escapa caracteres HTML peligrosos en strings que se interpolan dentro de
// templates de HTML (formatComment de respuestas a incidencia). Previene XSS
// cuando el resultado se almacena en ticket_reply.message y luego se renderiza
// con ReactHtmlParser o se parsea con DOMParser. Para texto plano del usuario
// sin necesidad de markup.
export const escapeHtml = (input) => {
    if (input === null || input === undefined) return ''
    return String(input)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

const STOREHUB_BOT_LOGO = `${process.env.PUBLIC_URL}/img/logo/logo-light-streamline.png`

export const isStoreHubBot = (user) => {
    if (!user) return false
    if (user.is_bot === true) return true
    const fullName = `${user.name || ""} ${user.lastname || ""}`.trim().toLowerCase()
    return fullName.includes("storehub") && fullName.includes("bot")
}

export const withBotAvatar = (user) => {
    if (!user) return user
    if (isStoreHubBot(user)) {
        return { ...user, image: STOREHUB_BOT_LOGO }
    }
    return user
}

const formatterInputSelect = (data) => {

    const lastname = data?.lastname || ""
    const label = data?.name + " " + lastname || data?.label

    return { ...data, value: data?.id, label: label }
}

export const formatterInputSelectData = (data = []) => {
    let newData = []
    if (!isArray(data)) {
        return formatterInputSelect(data)
    }
    data.map(d => {
        const item = formatterInputSelect(d)
        newData = [...newData, item]
    })
    return newData
}
export const formatterInputSelectDataWithLabel = (data) => {
    let newData = []
    data.map(d => {
        const item = { ...d, value: d.id, }
        newData = [...newData, item]
    })
    return newData
}


export const formatterInputSelectDataNameAndLastName = (data) => {
    let newData = []
    data.map(d => {
        const item = { ...d, value: d.id, label: `${d.name} ${d.lastname}` }
        newData = [...newData, item]
    })
    return newData
}
export const formatterTimezonesSelectData = (data) => {
    let newData = []
    data.map(d => {
        const item = { ...d, value: d.id, label: d.code }
        newData = [...newData, item]
    })
    return newData
}

export const showNotification = (data) => {
    const { type, title, message, duration, placement } = data
    toast.push(
        <Notification title={title} type={type || "success"} duration={duration}>
            {message}
        </Notification>
        , { placement: placement || 'top-end' }
    )
}

export const showMessageError = (data) => {
    let errors = []
    if (isString(data)) {
        errors = [data]
    } else {
        for (const property in data) {
            errors = [...errors, data[property]]
        }
    }
    toast.push(
        <Notification title={'Error'} type="danger" duration={2500}>
            {errors.map((e, i) => <div key={i} ><p>{e}</p><br /></div>)}
        </Notification>
    )
}

export const showAlert = ({ type = 'success', message = '' }) => {
    toast.push(
        <Alert showIcon closable type={type}>
            {message}
        </Alert>,
        {
            offsetX: 0,
            offsetY: 0,
            transitionType: 'fade',
            block: true,
        }
    )
}
export const showInfo = ({ type = 'info', message = '' }) => {
    toast.push(
        <Alert showIcon closable type={type}>
            {message}
        </Alert>,
        {
            offsetX: 0,
            offsetY: 0,
            transitionType: 'fade',
            block: true,
        }
    )
}

export const scroller = (el) => setTimeout(() => document.getElementById(el) && document.getElementById(el).scrollTo(0, document.getElementById(el).scrollHeight), 100);

export const deleteDuplicateData = (data, newData) => {
    data = data.filter(i => i.id !== newData.id)
    return [newData, ...data]
}

export const deleteDuplicateDataToFinal = (data, newData) => {
    // Filtra para eliminar cualquier elemento en `data` que tenga el mismo `id` que `newData`
    data = data.filter(i => i.id !== newData.id);
    // Retorna el arreglo combinado con `newData` al final
    return [...data, newData];
}

export const parseHtml = (content) => {

    const htmlReg = /(<([^>]+)>)/ig

    if (!content) {
        return ''
    }
    const text = content.replace(htmlReg, '')
    return text.length > 60 ? text.substring(0, 57) + "..." : text
}

export const setAarrayById = (arrUno, arrDos) => {

    let result = [];
    for (let i = 0; i < arrUno?.length; i++) {
        for (let j = 0; j < arrDos?.length; j++) {
            if (arrUno[i].id === arrDos[j].id) {
                result.push(arrDos[j])
            }
        }
    };
    return formatterInputSelectData(result);
}

const formatterInputSelectUser = (data) => {

    return { ...data, value: data.id, label: `${data.name} ${data.lastname}` }
}

export const formatterInputSelectDataUser = (data) => {
    let newData = []
    if (!isArray(data)) {
        return formatterInputSelect(data)
    }
    data.map(d => {
        const item = formatterInputSelectUser(d)
        newData = [...newData, item]
    })
    return newData
}

export const setAarrayByIdUser = (arrUno, arrDos) => {

    let result = [];
    for (let i = 0; i < arrUno?.length; i++) {
        for (let j = 0; j < arrDos?.length; j++) {
            if (arrUno[i].id === arrDos[j].id) {
                result.push(arrDos[j])
            }
        }
    };
    return formatterInputSelectDataUser(result);
}
export const setArrayByName = (arrUno, arrDos) => {
    let result = [];
    for (let i = 0; i < arrUno?.length; i++) {
        for (let j = 0; j < arrDos?.length; j++) {
            if (arrUno[i] === arrDos[j].name) {
                result.push(arrDos[j])
            }
        }
    };
    return formatterInputSelectData(result);
}

export const addPageQuery = (query, page) => {
    if (query.includes('filter')) {
        let params = new URLSearchParams(query);
        params.set('page[number]', page)
        try {
            return decodeURIComponent(params);
        } catch (e) {
            console.log(e);
        }
    } else {
        return `${query}?page[number]=${page}`
    }
}

export const modifyItemData = (id, items) => {
    const modifiedData = items.find(item => item.id === id)
    return modifiedData
}
export const modifyItemDataReturnName = (id, items) => {
    const modifiedData = items.find(item => item.id === id)
    const dataName = modifiedData ? modifiedData.name : null
    return dataName
}
export const modifyItemDataArray = (id, items) => {
    const modifiedData = items.filter(item => item.id === id)
    return modifiedData
}


export const createArrayWithItemId = (items) => {
    let itemId = [];

    if (typeof items === 'object' && !Array.isArray(items)) {
        itemId.push(items.id);
    } else if (Array.isArray(items)) {
        items.map(d => {
            const item = d.id;
            itemId.push(item);
        });
    }

    return itemId;
}
export const setUserObject = (user) => {
    return {
        name: user.userName,
        lastname: user.userLastname,
        email: user.email,
        image: user.avatar,
        authority: user.authority
    }
}

export const getStoresWithCameras = (s = []) => {
    return orderArrayBy(s, 'name')
        .reduce((acc, cur) => {
            const cameras = cur?.props?.devices?.some(d => d?.device_type_id === 3)
            if (cameras) {
                const newStore = structuredClone(cur)
                newStore.props.devices = cur?.props?.devices.filter(d => d.device_type_id === 3).map(d => {
                    return {
                        id: d.id,
                        uuid: d.uuid,
                        video_player: d.video_player,
                        alias: d.alias,
                        device_type_id: d.device_type_id,
                        legacy_name: d.legacy_name,
                        location: d.location,
                        name: d.name,
                        online: d.online,
                    }
                })
                acc.push({
                    id: newStore.id,
                    name: newStore.name,
                    address: newStore.address,
                    props: {
                        devices: newStore.props.devices
                    }
                })
            }
            return acc
        }, [])
}

export const filterStoreCameras = (stores) => {
    let list = []
    stores.map(store => {
        const cameras = []
        store?.props?.devices.map(device => { device.device_type_id === 3 && cameras.push(device) })
        let newStore = structuredClone(store)
        newStore.props.devices = cameras
        list.push(newStore)
    })
    return list
}

export const modifyDataDevicesInStores = (arrayOne, arrayTwo) => {
    const newData = []
    arrayOne.map((item) => {
        arrayTwo.map((store) => {
            if (item.store_id === store.id) {
                newData.push({
                    ...item,
                    label: `${item.location} - ${store.name}`,
                    name: `${item.location} - ${store.name}`

                }
                );
            }
        })
    });
    return newData
}

export const objectToFormData = (obj) => {
    const formData = new FormData();
    for (const key in obj) {
        if (obj[key]) {
            formData.append(key, obj[key]);
        }
    }
    return formData;
}

export const objectToArray = (obj = {}) => {
    return Object.entries(obj).map(([clave, valor]) => ({ [clave]: valor }))
}

export const searchInArray = (value = "", array = []) => {
    const val = value.toLocaleLowerCase().replace(/\s+/g, '')
    return array.filter(i => {
        let u = { ...i }
        if (u.name && u.lastname) u.fullname = u.name + " " + u.lastname
        return JSON.stringify(u).replace(/\s+/g, '').toLocaleLowerCase().includes(val)
    })
}


export const getSearchParam = param => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param)
}



export const changeValueObjectInArray = (array, data) => {
    const arrayList = structuredClone(array)
    const index = array.findIndex(d => d.id === data.id)
    arrayList[index] = data
    return arrayList
}


export const storeActive = (data) => {
    let newData = []
    data.map(d => {
        if (d.visible && d.visible === 1) {
            const item = d
            newData = [...newData, item]
        }
    })
    return newData
}

export const jsonToFormData = (json) => {
    const formData = new FormData();

    function traverse(obj, prefix = '') {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                const prop = prefix ? `${prefix}[${key}]` : key;

                if (typeof value === 'object' && value !== null && !(value instanceof File)) {
                    traverse(value, prop);
                } else if (value instanceof File) {
                    formData.append(prop, value);
                } else {
                    formData.append(prop, value);
                }
            }
        }
    }
    traverse(json);
    return formData;
}

export const orderByStoreName = (arr) => {
    const copyArr = [...arr]; // Crear una copia del array original
    copyArr.sort((a, b) => {
        const nameA = a.name.toLowerCase() || a.label.toLowerCase();
        const nameB = b.name.toLowerCase() || b.label.toLowerCase();

        if (nameA < nameB) { return -1; }
        if (nameA > nameB) { return 1; }
        return 0;
    });
    return copyArr;
}

export const orderArrayBy = (arr, value, order = 'asc') => {

    const orderAsc = order.toLowerCase() === 'asc' ? true : false

    const copyArr = [...arr]; // Crear una copia del array original
    copyArr.sort((a, b) => {
        const nameA = a[value].toLowerCase();
        const nameB = b[value].toLowerCase();

        if (nameA < nameB) { return orderAsc ? -1 : 1 }
        if (nameA > nameB) { return orderAsc ? 1 : -1 }

        return 0;
    });
    return copyArr;
}

export const isMobile = () => {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

export const renameFile = (files = []) => {
    let list = []
    files.map((file) => {
        const originalFileName = file.name;
        const fileExtension = originalFileName.split('.').pop();
        const newFileName = `${crypto.randomUUID()}.${fileExtension}`;
        const renamedFile = new File([file], newFileName, { type: file.type });
        list.push(renamedFile)
    })
    return list;
};

export const convertUrlToLink = (message) => {
  // Expresión regular para encontrar todas las URLs en una línea.
  // El corte incluye < > y comillas, no solo el espacio: esto corre sobre el
  // HTML crudo del mensaje, así que con [^ ]+ una URL pegada sin espacio a la
  // etiqueta siguiente se tragaba el markup entero (por ejemplo el
  // <span class="mention"> de una mención) y lo metía dentro del href.
  const regexURL = /https?:\/\/[^\s<>"']+/g;

  // Reemplaza las URLs encontradas en el mensaje con enlaces clicables
  let messageWithLinks = message.replace(/(<p>)(.*?)(<\/p>)/g, (match, p1, text, p3) => {
    return p1 + text.replace(regexURL, (url) => {
      return `<a href="${url}" target="_blank" class="font-bold">${url}</a>`;
    }) + p3;
  });
  return messageWithLinks;
};


  
 export const findTicketCategory = (array, id) => {
    const ticketCategory = array.find((item) => (item.id === id))
    return ticketCategory?.label
  }

  export const findUser = (array, id)=>{
    const user = array.find((item) => (item.id === id))
    if(user)  return  user.name +" " + user.lastname 
  }

 export const rankValues = (values, setter)  => {

    let valuesCopy = JSON.parse(JSON.stringify(values));

    valuesCopy.sort((a, b) => {
        if (b.tickets === a.tickets) { 
            return a.name.localeCompare(b.name);
        }
        return b.tickets - a.tickets; 
    });
    let currentRank = 1;
    for (let i = 0; i < valuesCopy.length; i++) {
        valuesCopy[i].ranking = currentRank++;
    }
    setter(valuesCopy); 
} 
/* export const rankValues = (values, setter) => {

    let valuesCopy = JSON.parse(JSON.stringify(values));
    valuesCopy = valuesCopy.filter(value => value.tickets > 0);
    valuesCopy.sort((a, b) => {
        if (b.tickets === a.tickets) { 
            return a.name.localeCompare(b.name);
        }
        return b.tickets - a.tickets; 
    });
    let currentRank = 1;
    for (let i = 0; i < valuesCopy.length; i++) {
        valuesCopy[i].ranking = currentRank++;
    }
    setter(valuesCopy); 
} */

export  const transformDataDasboard = (data, setter) => {
    let transformed = {
      name: [],
      tickets: []
    };

    data.forEach(item => {
      transformed.name.push(item.name);
      transformed.tickets.push(item.tickets);
    });

    setter(transformed);
  } 


  export const findTagType = (tagTypeId, tagTypes) => {
    const tag = tagTypes.find(tag => tag.id === tagTypeId);
    if (tag) {
        tag.label = tag.name;
    }
    return tag;
}

// Parsea de forma segura strings i18n del backend ({"es":"...","en":"..."}).
// Si llega null/undefined/JSON malformado o falta la key del idioma, devuelve fallback
// en lugar de tirar una excepcion no atrapada que crashea el render de toda la fila.
export const safeParseI18n = (raw, lang = 'es', fallback = '—') => {
    if (raw == null) return fallback
    // Si ya es objeto (algun endpoint puede devolverlo parseado), no parsear de nuevo.
    if (typeof raw === 'object') return raw?.[lang] ?? fallback
    if (typeof raw !== 'string') return fallback
    try {
        return JSON.parse(raw)?.[lang] ?? fallback
    } catch {
        return fallback
    }
}